@if (display) {
	<p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')"
		header="{{ title }}"
		[(visible)]="display"
		[responsive]="true"
		showEffect="fade"
		[modal]="true"
		appendTo="body"
	>
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
		<!-- #region BODY -->
		<div class="container-md">
			<div class="ui-grid-row">
				<div class="ui-grid-col-12">
					<p-messages [(value)]="messages"></p-messages>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-6">
					<label for="vehicleQualityCommitmentDate" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.breakdown.breakdownFollowing.vehicleQualityCommitmentDate' | translate
					}}</label>
					<div class="p-0"></div>
					<p-datepicker
						[(ngModel)]="vehicleQualityCommitmentDate"
						[showTime]="false"
						[style]="{ width: '200px' }"
						dateFormat="{{ i18n.dateFormat }}"
						showIcon="true"
						appendTo="body"
						[disabled]="!formManipulation"
					></p-datepicker>
				</div>
				<div class="col-sm-6">
					<label for="vehicleRentingDate" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.breakdown.breakdownFollowing.vehicleRentingDate' | translate }}
					</label>
					<div class="p-0"></div>
					<p-datepicker
						[(ngModel)]="vehicleRentingDate"
						[showTime]="false"
						[style]="{ width: '200px' }"
						dateFormat="{{ i18n.dateFormat }}"
						showIcon="true"
						appendTo="body"
						[disabled]="!formManipulation"
					></p-datepicker>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-6">
					<label for="vehicleReplacement" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.breakdown.breakdownFollowing.vehicleReplacement' | translate
					}}</label>
					<div class="p-0"></div>
					<input
						type="text"
						id="vehicleReplacement"
						class="form-control custom-input"
						[(ngModel)]="entity.vehicleReplacement"
						[disabled]="!formManipulation"
					/>
				</div>
				<div class="col-sm-6">
					<label for="replacementVehicleCollectionDate" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.breakdown.breakdownFollowing.replacementVehicleCollectionDate' | translate }}
					</label>
					<div class="p-0"></div>
					<p-datepicker
						[(ngModel)]="replacementVehicleCollectionDate"
						[showTime]="false"
						[style]="{ width: '200px' }"
						dateFormat="{{ i18n.dateFormat }}"
						showIcon="true"
						appendTo="body"
						[disabled]="!formManipulation"
					></p-datepicker>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-6">
					<label for="replacementVehicleReturnDate" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.breakdown.breakdownFollowing.replacementVehicleReturnDate' | translate
					}}</label>
					<div class="p-0"></div>
					<p-datepicker
						[(ngModel)]="replacementVehicleReturnDate"
						[showTime]="false"
						[style]="{ width: '200px' }"
						dateFormat="{{ i18n.dateFormat }}"
						showIcon="true"
						appendTo="body"
						[disabled]="!formManipulation"
					></p-datepicker>
				</div>
				<div class="col-sm-6"></div>
			</div>
			<!-- ACTIVE -->
			@if (!isNew) {
				<div class="row mt-3">
					<div class="col-12">
						<label for="cardType-enabled" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
							{{ 'general.active' | translate }}
						</label>
						<input
							class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
							type="checkbox"
							[ngModel]="!entity.disabled"
							[disabled]="true"
						/>
					</div>
				</div>
			}
			@if (!isNew) {
				<div class="row mt-3">
					<app-doc-table
						type="BREAKDOWN_FOLLOWING"
						[entity]="entity"
						[nested]="true"
						[ids]="ids"
						(return)="refresh()"
					>
					</app-doc-table>
				</div>
			}
		</div>
		<!-- #endregion BODY -->
	</div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
			<div class="d-flex justify-content-center bd-highlight">
				<div class="p-2 bd-highlight">
					@if (isNew) {
						<div>
							<button class="btn custom-button" (click)="saveChanges()" [disabled]="!formManipulation" i18n>
								{{ 'general.create' | translate }}
							</button>
						</div>
					}
					@if (!isNew) {
						<div>
							<button class="btn custom-button" (click)="saveChanges()" [disabled]="!formManipulation" i18n>
								{{ 'general.save' | translate }}
							</button>
						</div>
					}
				</div>
			</div>
		</ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}
